export const formatCurrency = (
    base: number,
    precision: number = 2,
    sign: boolean = false,
): string => {
    let signDisplay = ''

    if (base > 0) {
        signDisplay = '+'
    }

    return (sign ? signDisplay : '') + new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: precision,
        maximumFractionDigits: precision,
    }).format(+base / 100)
}
